/**!
 * Created by Leonardo Cheslacki on 22/02/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/**
 *
 * @type {{}}
 */
module.exports.main = {
    /**
     * Paths of src for compact min.
     */
    paths: [
        'resources/animate/auth/welcome/welcome',
        'resources/animate/student/dashboard/dashboard',
        'resources/animate/student/profile/profile',
        'resources/animate/student/library/library',
        'resources/animate/student/libraryFiles/libraryFiles',
        'resources/animate/student/libraryAudios/libraryAudios',
        'resources/animate/student/libraryVideos/libraryVideos',
        'resources/animate/student/libraryVideosPlayer/libraryVideosPlayer',
        'resources/animate/student/schoolFiles/schoolFiles',
        'resources/animate/games/activity/activity001/activity001',
        'resources/animate/games/activity/activity002/activity002',
        'resources/animate/games/activity/activity003/activity003',
        'resources/animate/games/activity/activity004/activity004',
        'resources/animate/games/activity/activity005/activity005',
        'resources/animate/student/game/game',
        'resources/animate/student/gameActivity/gameActivity',
        'resources/animate/student/gameActivityLevels/gameActivityLevels'
    ]
};

/**
 *
 * @type {{}}
 */
module.exports.game = {
    /**
     * Pseudos buttons.
     */
    pseudos: ['unvisited', 'hover', 'active']
};

/**
 *
 * @type {{}}
 */
module.exports.memory = {
    /**
     * Pseudos buttons.
     */
    pseudos: ['effect', 'unvisited', 'hover', 'active']
};

/**
 *
 * @type {{}}
 */
module.exports.auth = {
    /**
     * Auth.
     */
    welcome: null
};

/**
 *
 * @type {{}}
 */
module.exports.default = {
    routes: {
        api: {
            api_profile: 'api/profile',
            api_library_files: 'api/library/files',
            api_library_audios: 'api/library/audios',
            api_library_videos: 'api/library/videos',
            api_library_videos_player: 'api/library/videos/player',
            api_activity: 'api/game/activity',
            api_activity_levels: 'api/game/activity-levels',
            api_activity_template: 'api/game/activity-template',
            api_digital: 'api/game/digital',
            api_digital_levels: 'api/game/digital-levels',
            api_digital_template: 'api/game/digital-template',
            api_school_files: 'api/school/files'
        },
        web: {
            uri_login: '',
            uri_logout: 'logout',
            uri_profile: 'student/profile',
            uri_dashboard: 'student/dashboard',
            uri_library: 'student/library',
            uri_library_files: 'student/library/files',
            uri_library_audios: 'student/library/audios',
            uri_library_videos: 'student/library/videos',
            uri_library_videos_player: 'student/library/videos/player',
            uri_student: 'student',
            uri_game: 'student/game',
            uri_activity: 'student/game/activity',
            uri_activity_levels: 'student/game/activity-levels',
            uri_activity_level: 'student/game/activity-level',
            uri_digital: 'student/game/digital',
            uri_digital_levels: 'student/game/digital-levels',
            uri_digital_level: 'student/game/digital-level',
            uri_school_files: 'student/school/files'
        }
    }
};

/**
 *
 * @param responsive_active Allow replies, 'true' or 'false'.
 * @param responsive_replies Replies by, 'width', 'height' or 'both'.
 * @param scale_active Scale to fill visible area, 'true' or 'false'.
 * @param scale_type Adjust in display 'center' or stretch to fit 'stretch', "1 or 2".
 * @param dom_containers Array containers resize, 'elements'.
 */
module.exports.make = {
    responsive_active: true,
    responsive_replies: 'both',
    scale_active: false,
    scale_type: 1
};
